import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../../..';
import { getErrorText } from '../helpers';
import _ from 'lodash';

type Params = { messageTimetoken: string; roomId: string };
type Response = boolean;

export const updateRaiseHandMessage = createAsyncThunk<Response, Params, { rejectValue: string }>(
  'pubnub/updateRaiseHandMessage',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;
      const { raiseHand } = pubnubReducer;
      const message = _.find(raiseHand.messages, { timetoken: data.messageTimetoken });

      if (!message) {
        throw new Error('NoSuchMessage');
      }

      const messageData = JSON.parse(message.message);
      const messageActionUpdateArr = Object.values(message.actions?.update || {})?.[0] || [];
      const messageActionUpdateInfo = Object.keys(message.actions?.update || {})[0];
      const messageUpdateActionTimeToken = messageActionUpdateArr[0]?.actionTimetoken;
      const messageActionUpdateInfoParsed = JSON.parse(messageActionUpdateInfo || '{}');
      const currentAlreadySpeakTotal = messageActionUpdateInfoParsed.alreadySpeakTotal || messageData.alreadySpeakTotal;

      if (pubnubReducer.pubnub) {
        if (messageUpdateActionTimeToken) {
          await pubnubReducer.pubnub.removeMessageAction({
            channel: data.roomId,
            messageTimetoken: `${message.timetoken}`,
            actionTimetoken: `${messageUpdateActionTimeToken}`,
          });
        }

        await pubnubReducer.pubnub.addMessageAction({
          channel: data.roomId,
          messageTimetoken: `${message.timetoken}`,
          action: {
            type: 'update',
            value: JSON.stringify({
              ...messageData,
              alreadySpeakTotal: `${Number(currentAlreadySpeakTotal) + 1}`,
            }),
          },
        });

        return true;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
